import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { CourseCategoryProvider } from './context/CourseCategoryContext';
import { ProgramCategoryProvider } from './context/ProgramCategoryContext';
import { CategoryProvider } from './context/CategoryContext';
import { LecturerProvider } from './context/LecturerContext';
import { RatingProvider } from './context/RatingContext';
import { ProgrammeProvider } from './context/ProgrammeContext';
import { CourseProvider } from './context/CourseContext';
import { DepartmentProvider } from './context/DepartmentContext';
import { DocumentProvider } from './context/DocumentContext';
import { ProfileProvider } from './context/ProfileContext';
import { DashboardProvider } from './context/DashboardContext';
import { SubscriptionPlanProvider } from './context/SubscriptionPlanContext';
import { SubscribedUserProvider } from './context/SubscribedUserContext';
import {CourseContentProvider} from './context/CourseContentContext';
import { ResumeSubscribedUserProvider } from './context/ResumeSubscribedUserContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename="">
    <CourseCategoryProvider>
      <CategoryProvider>
      <ProgramCategoryProvider>
        <LecturerProvider>
          <RatingProvider>
            <ProgrammeProvider>
              <CourseProvider>
                <DepartmentProvider>
                  <DocumentProvider>
                    <ProfileProvider>
                      <DashboardProvider>
                        <SubscriptionPlanProvider>
                          <SubscribedUserProvider>
                            <CourseContentProvider>
                              <ResumeSubscribedUserProvider>
                                <App />
                              </ResumeSubscribedUserProvider>
                            </CourseContentProvider>
                          </SubscribedUserProvider>
                        </SubscriptionPlanProvider>
                      </DashboardProvider>
                    </ProfileProvider>
                  </DocumentProvider>
                </DepartmentProvider>
              </CourseProvider>
            </ProgrammeProvider>
          </RatingProvider>
        </LecturerProvider>
      </ProgramCategoryProvider>
      </CategoryProvider>
    </CourseCategoryProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
